import { useState } from 'react'

export default function Input({ label, name, error }) {
  const [inputValue, setInputValue] = useState('')
  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }
  const labelCss = inputValue ?
    'top-[6px] font-medium  text-text-label text-[10px] leading-3' :
    'top-[14px] text-sm text-text-placeholder\n' +
    '           group-hover:top-[6px] group-hover:font-medium group-hover:text-text-label group-hover:text-[10px] group-hover:leading-3'

  const inputCss = inputValue ? 'pt-[22px] pb-[6px]' : 'py-[14px] group-hover:pt-[22px] group-hover:pb-[6px]'
  const  errorInputCss = error ? 'border-support-danger-500' : ''
  return (<div className="group relative bg-white">
    <div className={`no-select z-10 absolute left-3 ${labelCss}`}>
      {label}
    </div>
    <div
      className={`flex relative h-12 rounded-lg px-3 bg-transparent tr border border-solid border-border-border ${inputCss} ${errorInputCss}`}
    >
      <input
        autoComplete="off"
        className="h-5 w-full outline-0 text-sm font-normal text-text-strong focus:outline-0"
        name={name}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
      />
    </div>
  </div>)
}